import React, { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Ritesh Kulkarni",
    role: "Head of Engineering",
    company: "FinTech Startup, Pune",
    quote:
      "Ascend Tech Solutions closed 6 backend engineering roles for us in 5 weeks. Structured screening, honest communication and zero recruiter noise — exactly what we needed.",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&q=75",
  },
  {
    name: "Ananya Menon",
    role: "HR Business Partner",
    company: "Enterprise Services, Bengaluru",
    quote:
      "For a non-IT bulk hiring drive, they built the pipeline in days and coordinated interviews across three cities. The communication was consistently clear and professional.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=75",
  },
  {
    name: "Nikhil Deshpande",
    role: "Founder & CEO",
    company: "SaaS Product, Mumbai",
    quote:
      "The team understood our stage as a startup and hired only for what mattered. Every candidate we interviewed was contextually relevant. That saves you weeks.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=75",
  },
  {
    name: "Priya Sharma",
    role: "Talent Acquisition Lead",
    company: "IT Services, Pune",
    quote:
      "We hired a Data Engineering lead in three weeks — a role that had been open for four months elsewhere. Their sourcing across specialised functions is genuinely strong.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=75",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 5500);
    return () => clearInterval(t);
  }, []);
  const t = TESTIMONIALS[i];
  return (
    <section className="section-pad bg-white">
      <div className="container-brand grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <span className="eyebrow">Testimonials</span>
          <h2 className="mt-3 heading-2">
            What Employers &amp; Candidates <br className="hidden md:block" />
            Say About Us
          </h2>
          <p className="mt-5 body-lg">
            A track record built on consistency, communication and the right
            hire at the right time — across IT, Non-IT and executive functions.
          </p>
          <div className="mt-8 flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                aria-label={`Show testimonial ${idx + 1}`}
                onClick={() => setI(idx)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  idx === i ? "bg-brand-royal w-8" : "bg-brand-border w-2"
                }`}
              />
            ))}
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="relative rounded-2xl border border-brand-border bg-brand-soft/60 p-8 md:p-10 shadow-[0_10px_40px_-12px_rgba(23,32,51,0.14)]">
            <Quote className="absolute -top-4 -left-4 w-10 h-10 text-brand-teal bg-white rounded-full p-2 border border-brand-border" />
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="w-4 h-4 text-amber-500 fill-amber-500" />
              ))}
            </div>
            <p key={t.name} className="text-lg md:text-xl text-brand-text leading-relaxed font-medium animate-fade-in-up">
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="mt-6 flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover border-2 border-brand-teal"
                loading="lazy"
              />
              <div>
                <div className="font-heading font-bold text-brand-navy">{t.name}</div>
                <div className="text-xs text-brand-textSoft">
                  {t.role} · {t.company}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
